import React, { useMemo } from "react";

import { BetStatusClassNames, BetStatusNames, T } from "../../../../../../constants";
import { MarketListItemRow } from "./market-list-item-row";
import { useTranslation } from "../../../../../../hooks";
import { BetStatus } from "../../../../../../enums";
import { Currency } from "../../../../shared";
import { BetType } from "../../../../../../models";

interface MarketListPropsItem {
  odds: number;
  result?: any;
  betType: BetType;
  roundId: number;
  gameName: string;
  status: BetStatus;
  winAmount: number;
  betAmount: number;
  handicap?: number;
  isExpress: boolean;
  marketName: string;
  possibleWin: number;
  ticketStatus: number;
  selectionName?: string;
  combinations: Array<number>;
  possibleCombinations: number;
}

export const MarketListItem: React.FC<MarketListPropsItem> = ({
  odds,
  result,
  status,
  betType,
  roundId,
  handicap,
  gameName,
  betAmount,
  winAmount,
  isExpress,
  marketName,
  possibleWin,
  ticketStatus,
  combinations,
  selectionName,
  possibleCombinations,
}) => {
  const t = useTranslation();

  const marketNameValue = useMemo(() => {
    return selectionName || marketName ? (
      `${t(marketName)} ${t(selectionName || "")} ${handicap ? handicap : ''}`
    ) : ''
  }, [selectionName, marketName, handicap]);

  const showRowConfig = useMemo(() => {
    return {
      betResult: status === BetStatus.Win || status === BetStatus.Lose,
      possibleWin: status === BetStatus.Pending,
    }
  }, [status]);

  return (
    <div className="bet-row">

      <div className="bet-row-wrp">
        <div className="bet-row-inner"></div>
        <div className="bet-row-result">
          <span className={`result-pp ${BetStatusClassNames[status]}`}>
            {ticketStatus !== BetStatus.Canceled
              ? t(BetStatusNames[status])
              : null}
          </span>
        </div>
      </div>

      <MarketListItemRow label={T.GAME_NAME} value={gameName}/>
      <MarketListItemRow label={T.ROUND_ID} value={roundId}/>
      {
        (selectionName || marketName) && (
          <MarketListItemRow label={T.BET} value={marketNameValue}/>
        )
      }
      {
        betType !== BetType.System && (
          <MarketListItemRow label={T.ODD} value={`x${odds}`} className={'ticket-odd'} />
        )
      }

      {
        !isExpress && (
          <MarketListItemRow label={T.STAKE} value={<Currency value={betAmount}/>} />
        )
      }
      {
        showRowConfig.possibleWin && (
          <MarketListItemRow label={T.POSSIBLE_WIN} value={possibleWin}/>
        )
      }
      {
        !!possibleCombinations && (
          <MarketListItemRow label={T.POSSIBLE_COMBINATIONS} value={possibleCombinations}/>
        )
      }
      {
        betType === BetType.System && (
          <MarketListItemRow label={T.COMBINATIONS} value={combinations.join(",")}/>
        )
      }
      {
        showRowConfig.betResult && (
          <>
            <MarketListItemRow label={T.WIN} value={<Currency value={winAmount}/>} />
            {/*<MarketListItemRow label={T.ROUND_RESULT} value={result}/>*/}
          </>
        )
      }
    </div>
  );
};
